import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "duplicate_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 2h15v15H2V2Zm17 4h2v15H6v-2h13V6ZM4 4h11v11H4V4Zm6.25 2h-1.5v2.75H6v1.5h2.75V13h1.5v-2.75H13v-1.5h-2.75V6Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }